import type {
    CampoEditavel,
    EdicaoClienteModel,
    EnderecoCliente,
} from "../models/edicaoClienteModel"

export enum EdicaoClienteActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    ATUALIZAR_ENDERECO = "ATUALIZAR_ENDERECO",
    ADICIONAR_ENDERECO = "ADICIONAR_ENDERECO",
    REMOVER_ENDERECO = "REMOVER_ENDERECO",
    ATUALIZAR_ATIVO = "ATUALIZAR_ATIVO",
    RESETAR = "RESETAR",
}

export type EdicaoClienteActionModel =
    | {
          type: EdicaoClienteActionsTypes.CARREGAR
          payload: EdicaoClienteModel
      }
    | {
          type: EdicaoClienteActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: CampoEditavel; valor: string | boolean }
      }
    | {
          type: EdicaoClienteActionsTypes.ATUALIZAR_ENDERECO
          payload: EnderecoCliente
      }
    | {
          type: EdicaoClienteActionsTypes.ADICIONAR_ENDERECO
          payload: EnderecoCliente
      }
    | {
          type: EdicaoClienteActionsTypes.REMOVER_ENDERECO
          payload: { id: number }
      }
    | {
          type: EdicaoClienteActionsTypes.ATUALIZAR_ATIVO
          payload: { ativo: boolean }
      }
    | {
          type: EdicaoClienteActionsTypes.RESETAR
      }
